/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React, {useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ChecklistOutlined, LinkOutlined, ManageSearch} from "@mui/icons-material";
import {ESTADOSCONDUCTORES, ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Conductor from "../Dialogos/Dialogo_Conductor";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {useNavigate} from "react-router";
import ExportadorDatosConductores from "../Componentes/ExportadorDatosConductores";
import Dialogo_Links from "../Dialogos/Dialogo_Links";


const Seccion_Conductor = () => {
    const {props, setData, cargarNuevamente, setNumeroFilas} = useObtenerColleccionTabla2025({coleccion: 'conductores'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Conductor,
        titulo: 'Detalles del conductor',
        realizado: cargarNuevamente
    })
    const {Dialogo:DialogoLink, abrir:abrirLink} = useDialogo({
        Componente: Dialogo_Links,
        titulo: 'Links para compartir',
        realizado: cargarNuevamente
    })
    const navigate = useNavigate()
    const [cargando, setCargando] = useState(false)

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'listas':
                navigate('/listaConductor/' + data.id)
                break
            case 'links':
                abrirLink()
                break
            default :
                abrir(data)
        }
    }

    const buscar = async (e) => {
        console.log(e)
        let cc = e.replaceAll('.', '')
        let w = [where('cc', '==', cc)]
        setCargando(true)
        let doxs = await obtenerColWheres({col: 'conductores', wheres: w})
        if (doxs.res && doxs.data.length > 0) {
            setNumeroFilas(doxs.data.length)
            setData(doxs.data)
        } else {
            setData([])
            setNumeroFilas(0)
        }
        setCargando(false)

    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoLink/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de conductores'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        funcionBuscar={buscar}
                        placeholderBarra={'Numero de Cc'}
                        cargando={cargando}
                        ComponenteInferior={ExportadorDatosConductores}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Conductor

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombres'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombres', 'apellidos'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Numero de Cc',
        direccion: 'left',
        propiedad: 'cc',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSCONDUCTORES
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Listas',
        id: 'listas',
        icono: ChecklistOutlined
    },
    {
        nombre: 'Links',
        id: 'links',
        icono: LinkOutlined
    },
]